document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('ContactFooter');
  if (!form) return;

  const input = form.querySelector('#ContactFooter-email');
  const submitButton = form.querySelector('.footer__newsletter-submit');

  if (!input || !submitButton) return;

  const validateInput = () => {
    const isValid = input.validity.valid && input.value.length > 0;
    submitButton.disabled = !isValid;
  };

  input.addEventListener('input', validateInput);

  form.addEventListener('submit', function(event) {
    if (!form.checkValidity()) {
      event.preventDefault();
      // Optionally, add more specific error handling here
    } else {
      submitButton.classList.add('footer__newsletter-submit--loading');
      submitButton.disabled = true;
    }
  });

  // Initial validation check
  validateInput();
});